if (document.getElementById('googlemaps')) {
	async function initMap() {

		const mymap = "googlemaps";
		let markerCluster;
		let markers = [];
		let filter_ano = [];
		let filter_uf = [];
		let filter_categoria = [];
		let filter_entidade = [];
		let wWidth = jQuery(window).width();

		let startZoom = (wWidth < 460) ? 3 : 4;

		let mapOptions = {
			mapId: "388df8c2d422d5ae",
			center: { lat: -14, lng: -53 },
			zoom: startZoom,
			zoomControl: false,
			mapTypeControl: false,
			streetViewControl: false,
			fullscreenControl: false,
		};

		const { Map } = await google.maps.importLibrary("maps");
		const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

		const map = new Map(document.getElementById(mymap), mapOptions);

		// Click on the map hide the infoBox
		map.addListener("click", function () {
			jQuery("body").removeClass("noscroll");
			jQuery(".gmap__sidebar, #mapFormWrapper").removeClass("is--visible");
			jQuery(".mapa__filter").removeClass("opened");
		});

		// Adicionar markers
		getLocations(map);

		// Filter
		handleFilter(map);

		// Sidebar
		handleSidebar();

		// Map Custom Controls
		handleMapControls(map);


		function getLocations(map, ano, uf, categoria, entidade) {
			// If no map, return
			if (!map) {
				return false;
			}

			// Se não chamar um ano, usar o padrão (todos);
			if (!ano) {
				ano = "";
			}

			// Se não chamar um ano, usar o padrão (todos);
			if (!uf) {
				uf = "";
			}

			// Se não chamar um categoria, usar o padrão (todos);
			if (!categoria) {
				categoria = "";
			}

			// Se não chamar uma tematica, usar o padrão (todos);
			if (!entidade) {
				entidade = "";
			}

			// console.log("LOAD PINS: ", ano, " | ", categoria, " | ", entidade);

			jQuery.ajax({
				url: "/wp-admin/admin-ajax.php",

				data: {
					action: "getIniciativas",
					ano: ano,
					uf: uf,
					categoria: categoria,
					entidade: entidade,
				},

				dataType: "JSON",

				beforeSend: function (data) {
					jQuery(".mapa-loading").show();
				},

				error: function (data) {
					console.log("ERRO");
				},

				success: function (iniciativas) {
					// console.log({ iniciativas });
					removeMarkers();

					jQuery(iniciativas).each(function (k, pin) {
						addMarkers(map, pin);
					});
				},
				complete: function () {
					jQuery(".mapa-loading").hide();

					// Create marker cluster
					markerCluster = new markerClusterer.MarkerClusterer({ markers, map });
				},
			});
		}

		function addMarkers(map, pin) {
			const parser = new DOMParser();

			// A marker with a custom inline SVG.
			let pinSvgString = "";

			if (pin.categoria === "sistema-de-justica") {
				pinSvgString = `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="37.35" viewBox="0 0 30 37.35"><path fill="${pin.cor}" stroke-width="0px" d="M15,0C6.73,0,0,6.73,0,15c0,7.13,7.73,15.69,14.22,21.62l.8.73.78-.75c7.19-6.91,14.2-14.28,14.2-21.6C30,6.73,23.27,0,15,0"/><path fill="#fff" stroke-width="0px" d="M15,27.18c6.25,0,11.31-5.32,11.31-11.89S21.25,3.41,15,3.41,3.69,8.73,3.69,15.29s5.06,11.89,11.31,11.89"/><path fill="${pin.cor}" stroke-width="0px" d="M6.7,16.5c.14-1.05.49-2.07,1.06-3.04L13.77,3.11c.17.02.33.03.5.04.24.02.49.02.73.02h1.26l5.98,10.3c.58.96.92,1.98,1.06,3.04h-1.5c-.12-.8-.41-1.59-.85-2.32L15,3.93l-5.95,10.25c-.44.74-.73,1.53-.86,2.33h-1.49Z"/><path fill="${pin.cor}" stroke-width="0px" d="M23.3,16.51H6.71c.09,1.19.46,2.36,1.1,3.45,1.5,2.51,4.2,4,7.19,4s5.69-1.49,7.19-4c.66-1.07,1.03-2.25,1.12-3.45"/></svg>`;
			} else {
				pinSvgString = `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="37.35" viewBox="0 0 30 37.35"><path fill="${pin.cor}" stroke-width="0" d="M15,0C6.73,0,0,6.73,0,15c0,7.13,7.73,15.69,14.22,21.62l.8.73.78-.75c7.18-6.91,14.2-14.27,14.2-21.6C30,6.73,23.27,0,15,0"/><path fill="#fff" stroke-width="0" d="M15,27.18c6.25,0,11.31-5.32,11.31-11.89S21.25,3.41,15,3.41,3.69,8.73,3.69,15.3s5.07,11.89,11.31,11.89"/><path fill="${pin.cor}" stroke-width="0" d="M15.55,8.25c-.3-.9-.79-.9-1.1,0l-.99,2.96c-.3.9-1.32,1.65-2.27,1.68l-2.83.08c-.95.03-1.12.53-.38,1.13l2.3,1.86c.74.6,1.13,1.82.87,2.74l-.85,3.01c-.26.92.16,1.2.93.65l2.38-1.72c.77-.56,2.02-.56,2.79,0l2.38,1.72c.77.56,1.18.27.93-.65l-.85-3.01c-.26-.92.13-2.14.87-2.74l2.3-1.86c.74-.6.57-1.1-.38-1.13l-2.83-.08c-.95-.03-1.97-.78-2.27-1.68l-.99-2.96Z"/></svg>`;
			}

			const pinSvg = parser.parseFromString(
				pinSvgString,
				"image/svg+xml"
			).documentElement;

			let marker = new AdvancedMarkerElement({
				map,
				position: { lat: pin.lat, lng: pin.lng },
				content: pinSvg,
			});

			marker.addListener("click", () => {
				loadPinContent(pin);
			});

			markers.push(marker);
		}

		function removeMarkers() {
			if (!markers) {
				return;
			}

			map.setZoom(startZoom);
			map.setCenter({ lat: -14, lng: -53 });

			// Remove Markers from the mapa
			markers.forEach((marker) => {
				marker.map = null;
			});

			// Reset Markers array
			markers = [];

			// Clear MarkersCluster
			markerCluster?.clearMarkers();
		}

		function handleFilter(map) {
			// Toggle Filter
			jQuery(".filter__trigger").on("click", function () {
				jQuery(".mapa__filter").toggleClass("opened");
			});

			// Toggle Items
			jQuery(".filter__item").on("click", function () {
				jQuery(this).toggleClass("active");
				applyFilter();
			});

			// Reset Ano
			jQuery(".ano-all").on("click", function () {
				jQuery(".ano-control").removeClass("active");
				applyFilter();
			});

			// Reset UF
			jQuery(".uf-all").on("click", function () {
				jQuery(".uf-control").removeClass("active");
				applyFilter();
			});

			// Reset Categoria
			jQuery(".categoria-all").on("click", function () {
				jQuery(".categoria-control").removeClass("active");
				applyFilter();
			});

			// Reset Entidades
			jQuery(".entidade-all").on("click", function () {
				jQuery(".entidade-control").removeClass("active");
				applyFilter();
			});
		}

		function applyFilter() {
			filter_ano = [];
			jQuery(".ano-control.active").each(function (e) {
				filter_ano.push(jQuery(this).data("term"));
			});

			filter_uf = [];
			jQuery(".uf-control.active").each(function (e) {
				filter_uf.push(jQuery(this).data("term"));
			});

			filter_categoria = [];
			jQuery(".categoria-control.active").each(function (e) {
				filter_categoria.push(jQuery(this).data("term"));
			});

			filter_entidade = [];
			jQuery(".entidade-control.active").each(function (e) {
				filter_entidade.push(jQuery(this).data("term"));
			});

			// console.log(filter_ano, filter_uf, filter_categoria, filter_entidade);
			getLocations(map, filter_ano, filter_uf, filter_categoria, filter_entidade);

			jQuery(".filter__control, .filter__options, .filter__item").trigger(
				"mouseout mouseleave"
			);

			jQuery(".gmap__filter").removeClass("opened");
		}

		function handleSidebar(map) {
			jQuery(".sidebar__close").bind("click", function () {
				jQuery(".gmap__sidebar").removeClass("is--visible");
			});
		}

		function handleMapControls(map) {
			document.querySelector(".zoom__in").onclick = function () {
				map.setZoom(map.getZoom() + 1);
			};

			document.querySelector(".zoom__out").onclick = function () {
				map.setZoom(map.getZoom() - 1);
			};
		}

		function loadPinContent(pin) {
			let title = pin.title;
			let ano = pin.ano;

			// LOCAL
			let cidade = pin.cidade;
			let uf = pin.uf;
			let local = "";

			if (cidade.length > 0 || uf.length > 0) {
				local += '<span class="sidebar__label">Local:</span> ';

				if (cidade.length > 0) {
					local += cidade;
				}
				if (uf.length > 0) {
					local += " (" + uf + ")";
				}
			}

			// Corporação
			let corporacao = pin.corporacao;
			if (corporacao.length > 0) {
				corporacao =
					'<span class="sidebar__label">Instituição:</span> ' + corporacao;
			}

			let resumo = pin.resumo;
			let video = pin.video;
			let pdf = pin.pdf;
			let image_url = pin.image_url;
			let selo_url = pin.selo_url;

			let thumb = "";
			let selo = "";
			let buttons = "";

			let mapTop =
				wWidth < 768
					? jQuery(".mapa__main").offset().top - 36
					: jQuery(".mapa__main").offset().top;

			jQuery(".gmap__sidebar").removeClass("is--visible");

			// Use .promise().then() so it won't fire twice.
			// https://stackoverflow.com/questions/8790752/callback-of-animate-gets-called-twice-jquery
			jQuery("html, body")
				.stop()
				.animate({ scrollTop: mapTop }, 500)
				.promise()
				.then(function () {
					// console.log("animagetop:", mapTop);

					// Ano/Cor
					jQuery(".gmap__sidebar").removeClass(
						"is--2017 is--2018 is--2019 is--2010 is--2021-2022"
					);
					jQuery(".gmap__sidebar").addClass("is--" + ano);

					// Image
					if (image_url.length > 0) {
						thumb = '<img src="' + image_url + '" alt="" />';
					}
					jQuery(".sidebar__picture").html(thumb);

					// Selo
					if (selo_url.length > 0) {
						selo = '<img src="' + selo_url + '" alt="" />';
					}
					jQuery(".sidebar__selo").html(selo);

					// Buttons
					if (pdf.length > 0) {
						buttons +=
							'<a class="a-btn-cta has--border" href="' +
							pdf +
							'" target="_blank">Texto Completo</a>';
					}

					if (video.length > 0) {
						buttons +=
							'<a class="a-btn-cta has--border" href="' +
							video +
							'" target="_blank">Vídeo</a>';
					}

					jQuery(".sidebar__buttons").html(buttons);

					// Content
					jQuery(".sidebar__title").html(title);
					jQuery(".sidebar__local").html(local);
					jQuery(".sidebar__instituicao").html(corporacao);
					jQuery(".sidebar__resumo").html(resumo);

					jQuery("#escondido").animate({ left: "200px" }, 200, function () {
						jQuery(".gmap__sidebar").addClass("is--visible");
					});
				});
		}
	}

	// INIT GOOGLE MAPS
	initMap();
}
